export class RenommerFichier 
{
    subItemId:string;
    fileName:string;
    displayName:string;
}